// ChatHeader.jsx
import React from 'react';

const ChatHeader = () => {
      // Keep the library class so default styles apply; Tailwind adds our dark colors/layout.
  return (
    <div className="p-3 bg-blue dark:bg-surface">
      <div className="flex justify-between items-center w-full font-bold">
        <span className=" text-[0.9rem] text-white">Stuck? Ask me</span>
        <span className=" text-[0.6rem] text-gray-300">🤖 AI-generated · Ask your teacher if unsure</span>
      </div>
    </div>
  );
};

export default ChatHeader;